module.exports = __webpack_public_path__ + "img/0_prices.6798da45.svg";